module.exports = __webpack_public_path__ + "static/media/EBGaramond-SemiBold.04b1b9d9.eot";